import { useContext } from 'react';

import { ShortcutRegistryContext } from './ShortcutRegistryContext';

import type { ShortcutRegistryLike } from '@src/services/shortcuts/types';

export function useShortcutRegistry(): ShortcutRegistryLike {
  const registry = useContext(ShortcutRegistryContext);

  if (!registry) {
    throw new Error(
      'ShortcutRegistryContext is not available. Wrap tree with <ShortcutProvider>.',
    );
  }

  return registry;
}
